import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Grid, withStyles, Typography } from '@material-ui/core'
import ReactSelect from 'components/theme/Select'
import { selectContactsForGroup } from 'actions/tasks'
import { contactOptionsSelector } from 'selectors'

const styles = theme => ({
  paper: {
    [theme.breakpoints.down('sm')]: {
      padding: 20,
    },
  },
})

const NeedsFollowUp = ({
  contactOptions,
  contactsSelectedForGroup,
  automationTypeSelected,
  selectContactsForGroup,
  classes,
  selectedActionPrediction,
}) => {
  const customStyles = {
    control: provided => ({
      ...provided,
      borderColor: 'rgba(0, 0, 0, 0.23)',
      borderRadius: '28px',
      padding: '9px 0',
    }),
    menu: provided => ({
      ...provided,
      zIndex: 2,
    }),
  }

  const label =
    selectedActionPrediction === 'setNeedsFollowUp'
      ? 'Mark contacts that need follow-up. '
      : 'Mark contacts that do not need follow-up. '

  return (
    <div className={classes.paper}>
      <Grid container spacing={16}>
        {automationTypeSelected === 'stage' ? (
          <Grid item xs={12}>
            <Typography variant="h5" gutterBottom>
              {label}
            </Typography>
          </Grid>
        ) : (
          <Grid item xs={12}>
            <Typography variant="h5" gutterBottom>
              {label}
              {/* {`Select the contacts that you want to mark`} */}
            </Typography>
            <ReactSelect
              styles={customStyles}
              value={contactsSelectedForGroup}
              onChange={newValue => selectContactsForGroup(newValue)}
              closeMenuOnSelect={false}
              isMulti
              options={contactOptions}
              placeholder="Selected contacts"
            />
          </Grid>
        )}
      </Grid>
    </div>
  )
}

export default connect(
  state => ({
    contactOptions: contactOptionsSelector(state),
    contactsSelectedForGroup: state.tasks.addOrEdit.contactsSelectedForGroup,
    automationTypeSelected: state.tasks.addOrEdit.automationTypeSelected,
    selectedActionPrediction:
      state.tasks.addOrEdit.fields.selectedActionPrediction?.value,
  }),
  dispatch => bindActionCreators({ selectContactsForGroup }, dispatch),
)(withStyles(styles)(NeedsFollowUp))
